import React, { Fragment } from "react";
import CSSTransitionGroup from "react-transition-group/CSSTransitionGroup";

import { Row, Col } from "reactstrap";

import Mixed from "../Components/Mixed";

/**
 * マーケット推移グラフコンポーネント（トレンド）
 * @param {*} param0
 * @returns
 */

const TransitionGraph1 = ({ graphData }) => {
  //プロジェクト数と設立数を抜いた配列を作成
  const filterdData = graphData.map((array) => array.node);
  delete filterdData["projects"];

  //横軸
  const horizontalAxis = [];

  //グラフデータ
  const marketSeries = [
    {
      name: "受取会費",
      data: [],
      x: "memberFee",
    },
    {
      name: "寄付金",
      data: [],
      en: "donation",
    },
    {
      name: "自主事業",
      data: [],
      en: "businessRevenue",
    },
    {
      name: "受託事業",
      data: [],
      en: "trusteeRevenue",
    },
    {
      name: "助成金",
      data: [],
      en: "subsidy",
    },
    {
      name: "補助金",
      data: [],
      en: "bounty",
    },
    {
      name: "雑収入",
      data: [],
      en: "miscellaneous",
    },
  ];

  // marketSeriesのそれぞれのオブジェクトの data に 値をpushしていく
  // 受け取り会費 (index番号=0)だけは特別な処理
  console.log("dats", graphData);
  graphData.map((array) =>
    array.node.donation != 0 && array.node.year >= 2013
      ? (horizontalAxis.push(array.node.year),
        marketSeries.map((data, index) =>
          index == 0
            ? data.data.push(
                array.node.memberFee.replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,")
              )
            : data.data.push(array.node[data.en])
        ))
      : array.node.year
  );

  //グラフオプション
  const marketOptions = {
    chart: {
      type: "bar",
      height: 350,
      stacked: true,
      toolbar: {
        show: false,
      },
      // zoom: {
      //   enabled: true,
      // },
    },
    responsive: [
      {
        breakpoint: 480,
        options: {
          legend: {
            position: "bottom",
            offsetX: -10,
            offsetY: 0,
          },
        },
      },
    ],
    plotOptions: {
      bar: {
        horizontal: false,
      },
    },
    dataLabels: {
      enabled: false,
      offsetY: 10,
      style: {
        fontSize: "12px",
        colors: ["#495057"],
      },
      formatter: function (value, { seriesIndex, dataPointIndex, w }) {
        return w.globals.stackedSeriesTotals[dataPointIndex];
      },
    },

    colors: [
      "#e0f9ab",
      "#69d2ceb3",
      "#47a9f3c4",
      "#ffcb2db0",
      "#f49323b5",
      "#ffbbca",
      "#53599ab3",
    ],

    xaxis: {
      categories: horizontalAxis,
    },
    yaxis: {
      labels: {
        formatter(value) {
          return value.toLocaleString();
        },
      },
    },
    legend: {
      position: "right",
      offsetY: 40,
    },
    fill: {
      opacity: 1,
    },
    grid: {
      xaxis: {
        lines: {
          show: false,
        },
      },
    },
  };

  return (
    <Fragment>
      <CSSTransitionGroup
        component="div"
        transitionName="TabsAnimation"
        transitionAppear={true}
        transitionAppearTimeout={0}
        transitionEnter={false}
        transitionLeave={false}
      >
        <Row>
          <Col
            sm="12"
            md="12"
            lg="12"
            style={{ marginTop: 50, marginBottom: 30 }}
          >
            <Mixed graphSeries={marketSeries} graphOptions={marketOptions} />
          </Col>
        </Row>
      </CSSTransitionGroup>
    </Fragment>
  );
};

export default TransitionGraph1;
